/**
 * Ensures every axios request sends the current access token.
 * Order: `workspaceCrossAppSync` in-memory monitor user (if set), then `userManager.getUser()`,
 * then Vuex — avoids stale Bearer tokens when oidc storage lags after `/adopt` or `signinSilent`.
 */
import axios from "axios";
import offlineConfig from "./offlineMode";
import store from "../vuex/store";
import { getUserManager } from "../js/authentication/authentication";
import { getMonitorCurrentUserAccessToken } from "../services/workspaceCrossAppSync";

export function setupAxiosAuthInterceptor() {
  if (offlineConfig.isOfflineMode && offlineConfig.bypassAuth) {
    return;
  }

  axios.interceptors.request.use(
    async function(config) {
      try {
        var token = getMonitorCurrentUserAccessToken();
        const userManager = getUserManager();
        if (!token && userManager && typeof userManager.getUser === "function") {
          const user = await userManager.getUser();
          if (user && user.access_token) {
            token = user.access_token;
          }
        }
        if (
          !token &&
          store.state.authentication &&
          store.state.authentication.accessToken
        ) {
          token = store.state.authentication.accessToken;
        }
        if (token) {
          config.headers = config.headers || {};
          config.headers.Authorization = "Bearer " + token;
        }
      } catch (e) {
        console.warn("[axios] Auth interceptor (fresh token) failed:", e);
      }
      return config;
    },
    function(error) {
      return Promise.reject(error);
    }
  );
}

export default setupAxiosAuthInterceptor;
